import * as React from 'react';
import {connect} from 'react-redux';
import {ToggleSelectedRoadObject, toggleSelectedRoadObject, toggleSelectedType, ToggleSelectedType} from '../actions';
import * as selectors from '../selectors';
import LocationalState, {
    LocationalConfidence,
    LocationalConfidence_nb_no,
    LocationalRoadObjectType
} from '../LocationalState';
import {toRoadList} from '../../../formatters';
import {ConfidenceIcon} from './ConfidenceIcon';
import classNames = require('classnames');

interface DispatchProps {
    doToggleSelectedType: ToggleSelectedType;
    doToggleSelectedRoadObject: ToggleSelectedRoadObject;
}

interface StateProps {
    selectedTypes: number[];
    typesAndObjects: LocationalRoadObjectType[];
    showSynchronized: boolean;
    disableDescriptiveName: boolean;
}

type Props = StateProps & DispatchProps;

const mapStateToProps = (state: LocationalState): StateProps => {
    return {
        selectedTypes: selectors.selectedTypes(state),
        typesAndObjects: selectors.processedTypesAndObjects(state),
        showSynchronized: selectors.showSynchronizedObjects(state),
        disableDescriptiveName: selectors.disableDescriptiveName(state)
    };
};

const mapDispatchToProps: DispatchProps = ({
    doToggleSelectedType: toggleSelectedType,
    doToggleSelectedRoadObject: toggleSelectedRoadObject
});

class TypeListComponent extends React.Component<Props, {}> {

    render() {
        const {typesAndObjects, showSynchronized, disableDescriptiveName} = this.props;
        return (
            <div className="roadobject-type-list">
                {typesAndObjects.map(type => {
                    const isSynchronized = !type.isDirty;

                    if (isSynchronized && !showSynchronized) {
                        return null; // Visibility of synchronized objects is turned off.
                    }
                    const typeClasses = classNames(
                        {
                            'roadobject-type': true,
                            'selected': type.isSelected,
                            'synchronized': isSynchronized
                        });
                    const listClasses = classNames(
                        {
                            'roadobject-list': true,
                            'open': type.isSelected,
                            'synchronized': isSynchronized
                        }
                    );
                    return (
                        <div key={type.typeid}>
                            <div className={typeClasses} onClick={() => this.handleTypeClick(type.typeid)}>
                                <div className="flex">
                                    <div className={'roadobject-badge'}>
                                        {isSynchronized && (
                                            <ConfidenceIcon type={LocationalConfidence.confident} synchronized tooltip={'Alle vegobjektene er lagret i NVDB'}/>
                                        )}


                                        {!isSynchronized && (
                                            <ConfidenceIcon type={type.lowestLocationalConfidence} tooltip={`Vegobjekter med ${LocationalConfidence_nb_no[type.lowestLocationalConfidence]} stedfesting`}/>
                                        )}

                                    </div>

                                    <div className="roadobjecttype-name grow">
                                        {type.name} <span className="color-mid-gray">({type.numFeatures})</span>
                                    </div>


                                </div>
                            </div>

                            <div className={listClasses}>
                                {type.roadObjects.map(ro => {
                                    const subItemIsSynchronized = !ro.dirty;
                                    const roads = toRoadList(ro.locational);
                                    if (subItemIsSynchronized && !showSynchronized) {
                                        return null; // Skip displaying the item if synchronized and visibility of synchronized objects is off
                                    }
                                    const roClasses = classNames(
                                        {
                                            'roadObject-item': true,
                                            'selected': ro.isSelected
                                        });
                                    return (
                                        <div key={ro.id} className={roClasses} onClick={() => this.handleRoadObjectClick(ro.id)}>
                                            <div className={'roadobject-badge shrink'}>
                                                {!subItemIsSynchronized && (
                                                    <ConfidenceIcon type={ro.locationalConfidence} tooltip={`Vegobjektet har ${LocationalConfidence_nb_no[ro.locationalConfidence]} stedfesting`} size={'s'}/>
                                                )}
                                                {subItemIsSynchronized && (
                                                    <ConfidenceIcon type={LocationalConfidence.confident} synchronized tooltip={`Vegobjektet er lagret i NVDB`} size={'s'}/>
                                                )}


                                            </div>

                                            <div className={'roadobject-name grow'} title={ro.descriptiveName}>
                                                {disableDescriptiveName ? ro.name : ro.descriptiveName}
                                                <br/>
                                                <span className={'roadobject-road'}>{roads ? roads : 'Mangler stedfesting'}</span>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }

    handleTypeClick(typeId: number) {
        this.props.doToggleSelectedType(typeId);
    }

    handleRoadObjectClick(roId: string) {
        this.props.doToggleSelectedRoadObject(roId);
    }


}

export const TypeList = connect(mapStateToProps, mapDispatchToProps)(TypeListComponent);